/* amplifica-filters-exact.js
   Elimina SOLO "Región de la Araucanía" del selector de regiones
   y SOLO "Temuco" del selector de comunas.
   Usa comparaciones exactas normalizadas para evitar falsos positivos.
*/
(function(){
  'use strict';

  const REGION_EXACT = 'Región de la Araucanía';
  const COMUNA_EXACT  = 'Temuco';

  function norm(s){
    return (s||'').replace(/\s+/g,' ').trim().normalize('NFC').toLowerCase();
  }

  const regionNorm = norm(REGION_EXACT);
  const comunaNorm = norm(COMUNA_EXACT);

  function removeExactMatches(){
    try {
      // 1) Selects de regiones: eliminar option que coincida exactamente
      const regionSelects = document.querySelectorAll('#amplificaShippingLocationSelector select.amplifica-shipping__input-region');
      regionSelects.forEach(sel => {
        Array.from(sel.options).forEach(opt => {
          if (norm(opt.textContent) === regionNorm) {
            opt.remove();
            // console.log('[amplifica-filters] Eliminada región:', opt.textContent.trim());
          }
        });
      });

      // 2) Selects de comunas: eliminar option que coincida exactamente
      const comunaSelects = document.querySelectorAll('#amplificaShippingLocationSelector select.amplifica-shipping__input-comuna');
      comunaSelects.forEach(sel => {
        Array.from(sel.options).forEach(opt => {
          if (norm(opt.textContent) === comunaNorm) {
            opt.remove();
            // console.log('[amplifica-filters] Eliminada comuna:', opt.textContent.trim());
          }
        });
      });

      // 3) Fallback muy conservador: eliminar <li> cuya cadena normalizada sea exactamente igual
      //    (solo por si la app renderiza una lista en vez de <select>).
      const liItems = document.querySelectorAll('#amplificaShippingLocationSelector li');
      liItems.forEach(li => {
        const txt = norm(li.textContent);
        if (txt === regionNorm || txt === comunaNorm) {
          li.remove();
          // console.log('[amplifica-filters] Eliminado <li> exacto:', li.textContent.trim());
        }
      });
    } catch (err){
      // No interrumpir nada si hay error
      console.warn('amplifica-filters-exact error', err);
    }
  }

  function startObserver(){
    const container = document.getElementById('amplificaShippingLocationSelector');
    if (!container) return false;
    // Ejecutar limpieza inmediata (por si ya está renderizado)
    removeExactMatches();
    // Observar cambios posteriores
    const observer = new MutationObserver(removeExactMatches);
    observer.observe(container, { childList: true, subtree: true });
    return true;
  }

  // Reintentos cortos si el container aún no existe (hasta ~20s)
  let tries = 0;
  const maxTries = 40;
  const interval = setInterval(() => {
    if (startObserver() || ++tries >= maxTries) {
      clearInterval(interval);
    }
  }, 500);
})();
